<h2 mat-dialog-title>{{ data.title || 'Quick Tour' }}</h2>
<mat-dialog-content class="dialog-body">
  <div class="card" *ngFor="let item of data.items">
    <h3>{{ item.title }}</h3>
    <p>{{ item.description }}</p>
    <ul *ngIf="item.actions?.length">
      <li *ngFor="let a of item.actions">{{ a }}</li>
    </ul>
  </div>
  <mat-checkbox [(ngModel)]="dontShow">Don't show again</mat-checkbox>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Close</button>
  <button mat-flat-button color="primary" (click)="close()">Done</button>
</mat-dialog-actions>
